module.exports = __webpack_public_path__ + "static/gb120-db04be0d570eb7af6d3150dd8ec848a6.png";